import moment from 'moment';
import { ChatMessageType, getMessageType } from './messageUtils';
import { v4 as uuid } from 'uuid';
// import { getStepsFromStepList } from '../formUtils/stepUtils';
// import { sendFormMessage } from './sendSendbirdMessage';
const zlib = require('zlib');

export const convertBlobToBase64 = blob => new Promise((resolve, reject) => {

    if(typeof blob === "string"){
        const buffer = Buffer.from(blob, 'base64');
        let unzippedJson = zlib.unzipSync(buffer);
        resolve(unzippedJson);
        return;
    }
    // console.log(typeof blob);
    
    var reader = new FileReader();
    try{
        reader.readAsDataURL(blob); 
    }catch(err){
        reject(err);
        console.log(err);
    }

    reader.onloadend = function() {
        var base64data = reader.result;
        const tuffer = Buffer.from(base64data.split(',')[1], 'base64');
        zlib.unzip(tuffer, (err, tuffer) => {
            if (!err) {
            resolve(tuffer.toString());
            } else {
            // handle error
            console.log(err);
            reject(err);
            }
        });
    }
});

export async function channelSchema(channel, messageListQuery){
    let metadata = {};
    if(!(channel.data && channel.data !== "")){
        metadata = await channel.getAllMetaData((response, error) => {
            if(error){
                console.log(error);
            }else{
                return response;
            }
        });
    }else{
        metadata = JSON.parse(channel.data);
    }
    //console.log(metadata)

    return {
        rawData: channel,
        id: channel.url,
        participants: channel.members.map(member => member.userId),
        messageSource: messageListQuery,
        lastMessage : channel.lastMessage && await messageSchema(channel.lastMessage),
        createdAt: moment(channel.createdAt),
        updatedAt: moment(channel.lastMessage ? channel.lastMessage.createdAt : channel.createdAt),
        customType: channel.customType,
        metadata: metadata,
        mute: channel.myMutedState === "muted",
        name: metadata && metadata.topic,
        typingMembers: [],
        unreadMessageCount: (channel.unreadMessageCount && parseInt(channel.unreadMessageCount)) || 0
    }
}

export async function messageSchema(message){

		if(!message._sender) {
				return null
		}
    if(message.message === ""){
        return {
            rawData: message,
            id: message.messageId,
            chatId: message.channelUrl,
            createdAt: moment(message.createdAt),
            messageBody: {
                type: "ping"
            },
            sender: message._sender.userId,
            customType: message.customType,
            type: "ping",
            internalMessageId: message.messageId
        };
    }
    let messageBody = message.message;
    if(message.customType === 'application/octet-stream'){
        messageBody = await convertBlobToBase64(messageBody);
				
				try {
						messageBody = JSON.parse( messageBody );
				} catch ( e ) {
						console.error( 'Error while parsing Layer message body.' );
						return null
				}        
    }

    if(typeof messageBody === 'string' && message.customType === "application/json"){
        
        try {
            messageBody = JSON.parse( messageBody );
        } catch ( e ) {
            console.error( 'Error while parsing Layer message body.' );
            return null
        }
        
    }
    
    
    //console.log(messageBody)

    return {
        rawData: message,
        id: message.messageId,
        chatId: message.channelUrl,
        createdAt: moment(message.createdAt),
        messageBody: messageBody,
        sender: message._sender.userId,
        customType: message.customType,
        type: getMessageType({messageBody}),
        internalMessageId: messageBody.messageId  || (messageBody.payload && messageBody.payload.form && messageBody.payload.form.messageId)|| message.messageId
    }
}

// export function initialMessageSchema(chat, currentUserId, chatflow, content = {}, parentFormId = null){
//     const id = uuid();

//     const formData = {
//         formId: chatflow.formId,
//         chatId: chat.metadata.chatId,
//         messageId: id,
//         step: 0,
//         content,
//         editenable: 'N', // should define a rule. TEMP for fixing issue with mobile
//         modifiedBy: currentUserId,
//         modifiedAt: moment().unix(), //isValidMoment( documentElement.modifiedAt ) ? documentElement.modifiedAt.unix() : undefined,
//     }
//     if(parentFormId && parentFormId != null){
//         formData.parentFormId = parentFormId
//     }
//     const messageBody = {
//         chatId: chat.metadata.chatId,
//         from: currentUserId,
//         type: ChatMessageType.FORM,
//         payload: {
//             form : formData,
//             formNumber: "0",
//             platForm: "web",
//             version: "2"
//         },
//         messageId: id,
//     }

//     const message = {
//         rawData: undefined,
//         id,
//         chatId: chat.id,
//         createdAt: moment(),
//         messageBody,
//         sender: currentUserId,
//         customType: chatflow.id,
//         type: getMessageType({messageBody}),
//         internalMessageId: id
//     }

// 		if(chatflow.name == 'End Workday/Get Report'){
// 				const { metadata } = chat;
// 				const { type } = metadata;

// 				// let currentSectionSteps = getStepsFromStepList(type + "_" + formData.formId + "_" + formData.step);

// 				// if(!currentSectionSteps || currentSectionSteps == null){
// 				// 		currentSectionSteps = getStepsFromStepList(formData.formId + "_" + formData.step);
// 				// }
// 				// for (let section of currentSectionSteps.sections) {
// 				// 		for (let field of section.fields) {
// 				// 				if(field?.parameters?.autoSetCurrentTime == 'Y'){
// 				// 						formData.content[field.id] = {
// 				// 								data: {
// 				// 									dateTime: moment().format("L HH:mm"),
// 				// 									formatedDateTime: moment().format("YYYY/MM/DD HH:mm"),
// 				// 									time: moment().format("hh:mm A")
// 				// 								}
// 				// 						}
// 				// 				}
// 				// 		}
// 				// }
// 				formData.step = 1;
// 				//sendFormMessage(message.messageBody, chat, currentUserId);

// 		}

// 		return message;
// }

// export function initialCallMessageSchema(chat, currentUserId, chatflow, type, content={}){

//     const id = uuid();
//     const formData = {
//         formId: chatflow.formId,
//         chatId: chat.metadata.chatId,
//         messageId: id,
//         calltype : type,
//         step: 0,
//         content,
//         editenable: 'N', // should define a rule. TEMP for fixing issue with mobile
//         modifiedBy: currentUserId,
//         modifiedAt: moment().unix(), //isValidMoment( documentElement.modifiedAt ) ? documentElement.modifiedAt.unix() : undefined,
//     }

//     const messageBody = {
//         chatId: chat.metadata.chatId,
//         from: currentUserId,
//         type: ChatMessageType.CALL,
//         payload: {
//             form : formData,
//             formNumber: "0",
//             platForm: "web",
//             version: "2",
//         },
//         messageId: id,
//     }
//     return {
//         rawData: undefined,
//         id,
//         chatId: chat.id,
//         createdAt: moment(),
//         messageBody,
//         sender: currentUserId,
//         customType: chatflow.id,
//         type: getMessageType({messageBody}),
//         internalMessageId: id
//     }
// }

